import moment from 'moment';

const helper = {
  format: (date, format) =>
    moment(date).format(format),
  isBeforeNow: date =>
    moment(date).isBefore(moment()),
};
/* eslint-disable */
const timeHelper = {
  install(Vue, options) {
    Vue.prototype.$timeHelper = helper;
  },
};

export default timeHelper;



// WEBPACK FOOTER //
// ./src/helpers/time.js